import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ContourIntegration = () => (
  <QPhototModuleSubtopic
    title="Contour Integration"
    videos={[
      "https://www.youtube.com/embed/VJ8zeLwwgcs",
      "https://www.youtube.com/embed/okvjpfUxDsM",
      "https://www.youtube.com/embed/kYNofZOAJJ4"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_41.png"},
        {image:"/cvla_42.png"},
        {image:"/cvla_43.png"},
        {image:"/cvla_44.png"},
        {image:"/cvla_45.png"},
    ]}
    exampleVideos={[]}
  />
);

export default ContourIntegration;
